import axios from "axios";

export default {
	load(params = '', token) {
		let http = axios.create({
		  baseURL: process.env.VUE_APP_API_MOBILE_URL,
		  headers: {
		    Authorization: "bearer " + token,
		  },
		});

		return http.get('categorias' + params)
	},
}
